<template>
	<div id="app">
		<TopNav />
		<router-view class="view"></router-view>
		<Footer />
	</div>
</template>

<script>
import TopNav from './components/TopNav.vue'
import Footer from './components/Footer.vue'

export default {
	name: 'app',
	components: {
		TopNav,
		Footer,
	},
}
</script>

<style lang="scss">
$base-color: #B10B16;
$background-color: #28373B;
body {
	margin: 0;
	padding: 0;
}
#app {
	font-family: proxima-nova, neue-haas-unica, 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #28373B;
	margin: 0;
	padding: 0;
}

#content {
	padding: 10px;
	padding-bottom: 40px;
	&.no-spacing {
		padding-bottom: 10px;
	}
	&.no-padding {
		padding: 0;
	}
}

.wrapper {
	padding: 0;
	margin: 0;
	max-width: 1200px;
	margin: 0 auto;
}

a {
	color: $base-color;
}

h1, h2, h3 {
	color: $background-color;
}

p, ul, li {
	font-weight: 300;
	line-height: 1.5;
}

p.accent {
	background: $background-color;
	color: #fff;
	padding: 10px 15px;
}

h1 {
	font-size: 22pt;
	font-weight: 700;
}

a.btn {
	background: transparent;
	border: 1px solid $background-color;
	color: $background-color;
	text-align: center;
	display: inline-block;
	padding: 5px 25px;
	box-sizing: border-box;
	font-weight: 600;
	text-decoration: none;
	transition: .15s background, .15s color;
	&:hover {
		background: $background-color;
		color: #fff;
	}
}

@media (max-width: 500px) {
	h1 {
		font-size: 18pt;
	}
}

.lds-ring {
	display: inline-block;
	position: relative;
	width: 80px;
	height: 80px;
}

.lds-ring div {
	box-sizing: border-box;
	display: block;
	position: absolute;
	width: 32px;
	height: 32px;
	margin: 4px;
	border: 4px solid #b10a16;
	border-radius: 50%;
	animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
	border-color: #b10a16 transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
	animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
	animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
	animation-delay: -0.15s;
}
@keyframes lds-ring {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}

.v-enter-active,
.v-leave-active {
	transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
	opacity: 0;
}
</style>
